<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="display: flex; justify-content: space-between">
        <div class="select">
          <div class="item">
            <el-select v-model="tenantId" placeholder="租户选择" clearable style="width: 220px">
              <el-option
                v-for="item in tenantList"
                :key="item.id"
                :label="item.tenantName"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <el-button size="small" @click="toggleAllExpand(true)">一键展开</el-button>
          </div>
          <div class="item">
            <el-button size="small" @click="toggleAllExpand(false)">一键收起</el-button>
          </div>
          <div class="item">
            <el-button size="small" type="primary" @click="showAddRoot">新增下级</el-button>
          </div>
        </div>
      </div>

      <el-row :gutter="16" class="split-layout">
        <el-col :span="9">
          <el-card shadow="never" class="left-tree-card">
            <div slot="header" class="tree-header">菜单树</div>
            <el-input
              v-model="treeKeyword"
              size="small"
              clearable
              placeholder="搜索名称/权限标识"
              class="tree-search"
            />
            <el-tree
              ref="menuTree"
              :data="tabList"
              node-key="id"
              highlight-current
              :default-expand-all="false"
              :props="{ children: 'children', label: 'name' }"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
            >
              <span slot-scope="{ node, data }" class="tree-node">
                <span class="tree-node-label">
                  <span>{{ data.name }}</span>
                  <el-tag size="mini" type="info" class="type-tag">{{ typeName(data.type) }}</el-tag>
                </span>
                <span class="tree-node-actions">
                  <el-button type="text" size="mini" @click.stop="showAddChild(data)">新增下级</el-button>
                  <el-button type="text" size="mini" @click.stop="showEdit(data)">编辑</el-button>
                </span>
              </span>
            </el-tree>
          </el-card>
        </el-col>

        <el-col :span="15">
          <el-card shadow="never" class="right-form-card">
            <div slot="header" class="detail-header">
              <span>{{ title }}</span>
              <span class="detail-header-right">
                <el-tag v-if="!isEditMode" size="mini" type="info">查看模式</el-tag>
                <el-tag v-else size="mini" type="warning">编辑模式</el-tag>
                <span v-if="selectedNode && selectedNode.id" class="detail-id">ID: {{ selectedNode.id }}</span>
              </span>
            </div>

            <el-form :model="formData" label-width="110px" size="medium">
              <el-form-item label="租户" required>
                <el-select
                  v-model="formData.tenantId"
                  placeholder="租户"
                  clearable
                  style="width: 100%"
                  :disabled="!isEditMode"
                >
                  <el-option
                    v-for="item in tenantList"
                    :key="item.id"
                    :label="item.tenantName"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="名称" required>
                <el-input v-model="formData.name" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="类型" required>
                <el-select v-model="formData.type" placeholder="类型" style="width: 100%" :disabled="!isEditMode">
                  <el-option :value="1" label="目录" />
                  <el-option :value="2" label="菜单" />
                  <el-option :value="3" label="按钮" />
                </el-select>
              </el-form-item>
              <el-form-item label="父级ID">
                <el-input-number v-model="formData.parentId" :min="0" style="width: 100%" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="路径">
                <el-input v-model="formData.pathUrl" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="组件">
                <el-input v-model="formData.component" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="权限标识">
                <el-input v-model="formData.perms" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="图标">
                <el-input v-model="formData.icon" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="排序">
                <el-input-number v-model="formData.sort" :min="0" style="width: 100%" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="隐藏">
                <el-switch v-model="formData.visible" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="停用">
                <el-switch v-model="formData.status" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="formData.remark" type="textarea" :rows="3" :disabled="!isEditMode" />
              </el-form-item>
              <el-form-item label="接口映射(JSON)">
                <el-input
                  v-model="formData.apiMappings"
                  type="textarea"
                  :rows="4"
                  :disabled="!isEditMode"
                  placeholder='示例: ["POST /ta/admin/user/freeze","POST /ta/admin/user/unfreeze"]'
                />
              </el-form-item>
            </el-form>

            <div class="detail-actions">
              <el-button
                v-if="selectedNode && selectedNode.id && !isEditMode"
                type="primary"
                @click="enableEdit"
                >进入编辑</el-button
              >
              <el-button
                v-if="selectedNode && selectedNode.id && isEditMode"
                @click="cancelEdit"
                >取消编辑</el-button
              >
              <el-button v-if="isEditMode" type="primary" @click="handleSave">{{
                formData.id ? "保存修改" : "创建节点"
              }}</el-button>
              <el-button v-if="selectedNode && selectedNode.id" type="danger" @click="remove(selectedNode)"
                >删除当前节点</el-button
              >
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import api from "./api";
import { tenantInfo } from "@/common/publicApi";

const defaultForm = () => ({
  id: undefined,
  tenantId: "",
  parentId: 0,
  name: "",
  pathUrl: "",
  component: "",
  perms: "",
  icon: "",
  sort: 0,
  type: 2,
  visible: false,
  status: false,
  apiMappings: "[]",
  remark: "",
});

export default {
  data() {
    return {
      tenantId: "",
      tenantList: [],
      tabList: [],
      title: "新增节点",
      selectedNode: null,
      treeKeyword: "",
      isEditMode: true,
      formData: defaultForm(),
    };
  },
  watch: {
    treeKeyword(val) {
      this.$refs.menuTree && this.$refs.menuTree.filter(val);
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data || [];
        if (!this.tenantId && this.tenantList.length) {
          this.tenantId = this.tenantList[0].id;
        }
        this.handleSearch();
      }
    });
  },
  methods: {
    collectExpandedKeys() {
      if (!this.$refs.menuTree || !this.$refs.menuTree.store) {
        return [];
      }
      const nodesMap = this.$refs.menuTree.store.nodesMap || {};
      return Object.keys(nodesMap)
        .filter((key) => nodesMap[key] && nodesMap[key].expanded)
        .map((key) => Number(key))
        .filter((key) => Number.isFinite(key));
    },
    restoreExpandedKeys(keys = []) {
      if (!this.$refs.menuTree || !this.$refs.menuTree.store) {
        return;
      }
      const keep = new Set(keys.map((k) => Number(k)));
      const nodesMap = this.$refs.menuTree.store.nodesMap || {};
      Object.keys(nodesMap).forEach((key) => {
        const node = nodesMap[key];
        if (!node) return;
        node.expanded = keep.has(Number(key));
      });
    },
    typeName(type) {
      if (type === 1) return "目录";
      if (type === 2) return "菜单";
      return "按钮";
    },
    handleSearch(options = {}) {
      const { preserveExpanded = false, keepCurrentKey = null, resetSelection = true } = options;
      const expandedKeys = preserveExpanded ? this.collectExpandedKeys() : [];
      const params = {};
      if (this.tenantId || this.tenantId === 0) {
        params.tenantId = this.tenantId;
      }
      api.tree(params).then((res) => {
        if (res.code == 0) {
          this.tabList = res.data || [];
          this.$nextTick(() => {
            if (preserveExpanded) {
              this.restoreExpandedKeys(expandedKeys);
            }
            if (keepCurrentKey) {
              this.$refs.menuTree && this.$refs.menuTree.setCurrentKey(keepCurrentKey);
            }
          });
          if (resetSelection) {
            this.selectedNode = null;
            this.resetForm();
          }
        }
      });
    },
    handleNodeClick(row) {
      this.selectedNode = row;
      this.showEdit(row);
      this.isEditMode = false;
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return (
        (data.name || "").includes(value) ||
        (data.perms || "").includes(value) ||
        (data.apiMappings || "").includes(value)
      );
    },
    enableEdit() {
      this.isEditMode = true;
    },
    toggleAllExpand(expanded) {
      if (!this.$refs.menuTree || !this.$refs.menuTree.store) {
        return;
      }
      const nodesMap = this.$refs.menuTree.store.nodesMap || {};
      Object.keys(nodesMap).forEach((key) => {
        nodesMap[key].expanded = expanded;
      });
    },
    cancelEdit() {
      if (this.selectedNode && this.selectedNode.id) {
        this.showEdit(this.selectedNode);
        this.isEditMode = false;
      }
    },
    showAddRoot() {
      if (!this.selectedNode || !this.selectedNode.id) {
        return this.$message.warning("请先在左侧选择父级节点");
      }
      this.showAddChild(this.selectedNode);
    },
    showAddChild(row) {
      this.title = "新增下级";
      this.selectedNode = row;
      this.formData = defaultForm();
      this.formData.tenantId = row.tenantId;
      this.formData.parentId = row.id;
      this.isEditMode = true;
    },
    showEdit(row) {
      this.selectedNode = row;
      this.isEditMode = true;
      this.$nextTick(() => {
        this.$refs.menuTree && this.$refs.menuTree.setCurrentKey(row.id);
      });
      this.title = "编辑节点";
      this.formData = {
        id: row.id,
        tenantId: row.tenantId,
        parentId: row.parentId || 0,
        name: row.name || "",
        pathUrl: row.pathUrl || "",
        component: row.component || "",
        perms: row.perms || "",
        icon: row.icon || "",
        sort: row.sort || 0,
        type: row.type || 2,
        visible: !!row.visible,
        status: !!row.status,
        apiMappings: row.apiMappings || "[]",
        remark: row.remark || "",
      };
    },
    resetForm() {
      this.title = "新增节点";
      this.formData = defaultForm();
      this.formData.tenantId = this.tenantId || "";
      this.isEditMode = true;
    },
    handleSave() {
      if (!this.formData.tenantId && this.formData.tenantId !== 0) {
        return this.$message.error("请选择租户");
      }
      if (!this.formData.name) {
        return this.$message.error("请输入名称");
      }
      let apiMappings = this.formData.apiMappings;
      if (!apiMappings || !String(apiMappings).trim()) {
        apiMappings = "[]";
      }
      try {
        const parsed = JSON.parse(apiMappings);
        if (!Array.isArray(parsed)) {
          return this.$message.error("接口映射必须是JSON数组");
        }
        apiMappings = JSON.stringify(
          parsed
            .map((v) => (v == null ? "" : String(v).trim()))
            .filter((v) => !!v)
        );
      } catch (e) {
        return this.$message.error("接口映射JSON格式不正确");
      }
      const payload = {
        ...this.formData,
        apiMappings,
      };
      const req = this.formData.id ? api.update : api.add;
      req(payload).then((res) => {
        if (res.code == 0) {
          this.$message.success("操作成功");
          const keepId = this.formData.id;
          this.handleSearch({
            preserveExpanded: true,
            keepCurrentKey: keepId || null,
            resetSelection: false,
          });
          this.isEditMode = false;
        }
      });
    },
    remove(row) {
      this.$confirm("删除后将同时删除所有子节点，确认继续吗？", "提示", {
        type: "warning",
      }).then(() => {
        api.remove({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.selectedNode = null;
            this.resetForm();
            this.handleSearch();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style lang="less" scoped>
.split-layout {
  margin-top: 8px;
}

.left-tree-card,
.right-form-card {
  height: calc(100vh - 240px);
  overflow: auto;
}

.tree-header,
.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}

.tree-search {
  margin-bottom: 10px;
}

.detail-header-right {
  display: inline-flex;
  align-items: center;
}

.detail-id {
  color: #909399;
  font-weight: 400;
  font-size: 12px;
  margin-left: 8px;
}

.tree-node {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tree-node-label {
  display: inline-flex;
  align-items: center;
}

.type-tag {
  margin-left: 8px;
}

.tree-node-actions {
  margin-left: 8px;
}

.detail-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}
</style>
